export default __webpack_public_path__ + "static/media/single-rope-border-both.31e7fc0f.svg";